import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, num, dt, unitsOf } from "@/lib/api";
import { PageHeader, Card, Table, Field, Sel, Money, Tag } from "@/components/common";
import { Modal, SaveBtn, NewBtn } from "@/components/Modal";
import { PhotoUpload } from "@/components/PhotoUpload";
import { useAuth } from "@/context/AuthContext";

export default function Adjustments() {
  const { myLocs, activeItems, itemById } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [f, setF] = useState({ location_id: myLocs[0]?.id, item_id: "", qty: "", unit: "", kind: "waste", note: "" });
  const load = () => api.get("/adjustments").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    const q = Math.abs(Number(f.qty));
    try { await api.post("/adjustments", { ...f, qty: f.kind === "waste" || f.sign === "-" ? -q : q, photos: photos.map((p) => p.id) }); toast.success("Penyesuaian diposting"); setOpen(false); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader title="Penyesuaian stok & waste" sub="Koreksi tidak pernah mengubah transaksi lama; setiap koreksi menjadi entri ledger baru.">
        <NewBtn onClick={() => setOpen(true)} testid="new-adjustment-button">Penyesuaian</NewBtn>
      </PageHeader>
      <Card>
        <Table testid="adjustments-table" rows={rows} cols={[
          { h: "Kode", r: (r) => <span className="num text-xs font-semibold">{r.code}</span> }, { h: "Waktu", r: (r) => <span className="text-xs">{dt(r.created_at)}</span> },
          { h: "Lokasi", k: "location_name" }, { h: "Barang", k: "item_name" }, { h: "Jenis", r: (r) => <Tag tone={r.kind === "waste" ? "rose" : "sky"}>{r.kind === "waste" ? "Waste" : "Penyesuaian"}</Tag> },
          { h: "Qty", right: true, r: (r) => <span className="num font-semibold">{num(r.base_qty)} {r.base_unit}</span> }, { h: "Nilai", right: true, r: (r) => <Money v={r.value} /> },
          { h: "Catatan", k: "note" }, { h: "Oleh", r: (r) => r.created_by.name },
        ]} />
      </Card>
      <Modal open={open} onOpenChange={setOpen} title="Penyesuaian stok" testid="adjustment-modal">
        <div className="grid grid-cols-2 gap-3">
          <Field label="Lokasi"><Sel value={f.location_id} onChange={(v) => setF({ ...f, location_id: v })} options={myLocs.map((l) => ({ value: l.id, label: l.name }))} /></Field>
          <Field label="Jenis"><Sel testid="adjustment-kind-select" value={f.kind} onChange={(v) => setF({ ...f, kind: v })} options={[{ value: "waste", label: "Waste (keluar)" }, { value: "adjustment", label: "Penyesuaian (+/−)" }]} /></Field>
          <Field label="Barang" className="col-span-2"><Sel testid="adjustment-item-select" value={f.item_id} onChange={(v) => setF({ ...f, item_id: v, unit: itemById[v]?.base_unit })} placeholder="Pilih" options={activeItems.map((i) => ({ value: i.id, label: i.name }))} /></Field>
          {f.kind === "adjustment" && <Field label="Arah"><Sel value={f.sign || "+"} onChange={(v) => setF({ ...f, sign: v })} options={[{ value: "+", label: "Tambah (+)" }, { value: "-", label: "Kurang (−)" }]} /></Field>}
          <Field label="Jumlah"><input className="inp num" type="number" step="any" value={f.qty} onChange={(e) => setF({ ...f, qty: e.target.value })} data-testid="adjustment-qty-input" /></Field>
          <Field label="Satuan"><Sel value={f.unit} onChange={(v) => setF({ ...f, unit: v })} options={unitsOf(itemById[f.item_id]).map((u) => ({ value: u, label: u }))} /></Field>
          <Field label="Catatan" className="col-span-2"><input className="inp" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} /></Field>
        </div>
        <PhotoUpload value={photos} onChange={setPhotos} label="Foto bukti (opsional)" testid="adjustment-photo" />
        <SaveBtn onClick={save} testid="adjustment-save-button" />
      </Modal>
    </div>
  );
}
